import { LIMIT } from 'config/paginationConfig';

import { useDispatch, useSelector } from 'react-redux';
import { getApprovedRequest } from 'store/storageunits/sagaActions';
import {
  getApprovedFilesForDashboard,
  getHasMoreDataToRetrieve,
  getSearchString,
} from 'store/storageunits/selectors';
import {
  ExplorerMode,
  SortType,
  StorageUnitType,
} from 'store/storageunits/types';
import FileArea from '../components/FileArea';
import StorageUnitGrid from '../components/StorageUnitGrid';
import StorageUnitList from '../components/StorageUnitList';
import { useDashboard } from '../context';
import { useFetchViewStorageUnits } from '../hooks/useFetchViewStorageUnits';

const ApprovedFiles = () => {
  const searchString = useSelector(getSearchString);
  const { explorerMode } = useDashboard();
  const dispatch = useDispatch();
  const moreDataToRetrieve = useSelector(getHasMoreDataToRetrieve);

  const files = useSelector(getApprovedFilesForDashboard);

  const fetchParams = { limit: LIMIT, offset: 0, searchString };

  useFetchViewStorageUnits(getApprovedRequest, fetchParams);

  const fetchMore = async () => {
    dispatch(
      getApprovedRequest({
        limit: LIMIT,
        offset: files.length,
        searchString,
        replace: false,
      }),
    );
  };

  return (
    <FileArea
      dataLength={files.length}
      canFetchMore={moreDataToRetrieve}
      fetchMore={fetchMore}
    >
      {explorerMode === ExplorerMode.Grid ? (
        <StorageUnitGrid
          title='Approved files'
          type={StorageUnitType.File}
          units={files}
          showSorter
        />
      ) : (
        <StorageUnitList
          units={files}
          columns={[
            { label: 'Name', type: SortType.ALPHABETICAL },
            { label: 'Access' },
            {
              label: 'Last modified',
              type: SortType.LAST_MODIFIED,
            },
            { label: 'Locked' },
            { label: 'Downloaded' },
            { label: 'State' },
          ]}
        />
      )}
    </FileArea>
  );
};

export default ApprovedFiles;
